export const getTypeMap = (practiceType, implementationLevel) => {
  const numberOfCollections = implementationLevel === 1 ? 2 : 3
  const typeMap = {
    'educator-practices': {
      description: `Each educator is encouraged to mark done all ${numberOfCollections} educator practices in each pathway.`,
      title: 'Educator Practices',
      practiceType: 'educator',
    },
    'schoolwide-practices': {
      description: `Each educator is encouraged to mark done all ${numberOfCollections} schoolwide practices in each pathway.`,
      title: 'Schoolwide Practices',
      practiceType: 'sitewide',
    },
    'student-activities': {
      description:
        'Each educator is encouraged to mark done any number of student activities based on the grade(s) they teach.',
      title: 'Student Activities',
      practiceType: 'activity',
    },
  }

  return typeMap[practiceType]
}
